import { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, } from "reactstrap";


// import {
//   AddTopDoctorsAPI,
//   createLabCategory,
//   getDoctorsList,
//   getLabCategory,
//   updateLabCategory,
// } from "../../api/master/indes";


import { BASE_URL_IMG } from "../../assets/constants";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
  TooltipComponent,
  UserAvatar,
} from "../../components/Component";
import useLogout from "../../hooks/useLogout";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import { getMedicinesAPI, updateDoctorAPI } from "../../api/doctor";
import ApiPaginationDataTable from "../../MyComp/UI/DataTable/ApiPaginationDataTable";
import { getSmartInitials } from "../../utils/Utils";
import { UserAvatarCell } from "../../MyComp/ImageView/UserAvatarCell";
import { useLocation } from "react-router-dom";



const User = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      server_search: "",
      page: 1,
      limit: 25,
    },
  });

  const { logout } = useLogout();
  const navigate = useNavigate();
  // Separate table state from form
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const [imageOpen, setImageOpen] = useState(false);
  //pagination
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);

  

  // pagination
  const handlePerRowsChange = (newPerPage, page) => {
    const rows = isNaN(newPerPage) ? totalRows : newPerPage;
    setPerPage(rows);
    setValue("page", page);
    console.log("rows", page, rows);
  };
  const handlePageChange = (page) => {
    console.log("page", page);
    setPerPage(perPage);
    setCurrentPage(page);
    setValue("page", page);
  };

  const MAX_DOCTORS = 20;
  const [selectedDoctors, setSelectedDoctors] = useState([]);

 



  useEffect(() => {
    if (!tableData?.length) return;

    setSelectedDoctors((prev) => {
      const prevIds = new Set(prev.map((d) => d.id));

      const preSelected = tableData.filter((row) => row?.isSelected && !prevIds.has(row.id));

      return [...prev, ...preSelected];
    });
  }, [tableData]);

  // const handleDoctorSelect = (row, checked) => {
  //   setSelectedDoctors((prev) => {
  //     if (checked) {
  //       if (prev.length+2 >= MAX_DOCTORS) {
  //         toast.warning("You cannot select more than 20 doctors.");
  //         return prev;
  //       }

  //       if (prev.some((d) => d.id === row.id)) return prev;

  //       return [...prev, row];
  //     }


  //     return prev.filter((d) => d.id !== row.id);
  //   });

  //   setTableData((prev) =>
  //     prev.map((item) =>
  //       item.id === row.id ? { ...item, isSelected: checked } : item
  //     )
  //   );


  //   // if (!checked) {
  //   //   deleteTopDoctor(row.doctorId);
  //   // }
  // };

  // const handleRemoveTopDoctors = () => {
  //   if (selectedDoctors.length === 0) {
  //     toast.warning("Please select at least one doctor to remove.");
  //     return;
  //   }

  //   setLoading(true);

  //   const doctorIds = selectedDoctors.map((d) => d.doctorId);

  //   const body = {
  //     doctors: doctorIds,  
  //     isSelected: false,  
  //   };

  //   AddTopDoctorsAPI(body)
  //     .then((res) => {
  //       const status = res?.data?.status;

  //       if (status === true) {
  //         setSelectedDoctors([]);
  //         serverSideSearch();
  //         toast.success("Doctor(s) removed from Top Doctors.");
  //       } else if (status === "expired") {
  //         toast.error(res.data.message);
  //         logout();
  //       } else {
  //         toast.error(res?.data?.message || "Failed to remove doctors.");
  //       }
  //     })
  //     .catch((err) => {
  //       console.error("Remove top doctors error:", err);
  //       toast.error("Something went wrong. Please try again.");
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };

  const columns = [
    // {
    //   name: "Item Id",
    //   selector: (row) => row?.item_id,
    //   sortable: true,

    // },

    {
      name: "Name",
      selector: (row) => row?.name,
      sortable: true,
      cell: (row) => (
        <div
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.4",
          }}
        >
          {row?.name}
        </div>
      ),
      wrap: true,
    },

    {
      name: "Price",
      selector: (row) => row?.price,
      sortable: true,

    },
    {
      name: "Category ",
      selector: (row) => row?.category,
      sortable: true,
       cell: (row) => (
        <div
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.4",
          }}
        >
          {row?.category}
        </div>
      ),
      wrap: true,
      

    },
    {
      name: "Manufacturer",
      selector: (row) => row?.manufacturer,
      sortable: true,
         cell: (row) => (
        <div
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.4",
          }}
        >
          {row?.manufacturer}
        </div>
      ),
      wrap: true,
    },

    
    {
      name: "Original Price",
      selector: (row) => row?.original_price,
      sortable: true,

    },
     {
      name: "Discount",
      selector: (row) => row?.discount,
      sortable: true,

    },
    {
      name: "Pack Type",
      selector: (row) => row?.pack_type,
      sortable: true,

    },
    {
      name: "Salt Name",
      selector: (row) => row?.salt,
      sortable: true,
      width: "200px",

    },
     {
      name: "Action",
      selector: (row) => row?.Action,
       cell: (row) => (
              <Button outline color="warning" size="xs" onClick={() => navigate("/medicine/add-medicine", { state: { mode: "Edit", data: row } })}>
                <Icon name="edit" />
              </Button>
            ),
      sortable: true,

    },
  ]


  useEffect(() => {
    serverSideSearch();
  }, [perPage, currentPage]);
  const serverSideSearch = (data) => {
    const body = {
      search: watch("server_search"),
      page: currentPage,
      limit: perPage,
    };
    setLoading(true);
    getMedicinesAPI(body)
      .then((res) => {
        const status = res.data.status;
        if (status === true) {
          setLoading(false);
          console.log("server side res", res?.data?.data?.result);
          setTotalRows(res?.data?.data?.totalRecords);
          setValue("limit", res?.data?.data?.totalRecords);
          setTableData(res?.data?.data?.medicines);
        } else if (status === false) {
          setLoading(false);
          setTableData([]);
        } else if (status === "expired") {
          setLoading(false);
          logout();
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("catch error", err);
      });
  };
  useEffect(() => {
    if (watch("server_search")?.length == 0) {
      serverSideSearch();
    }
  }, [watch("server_search")]);



  return (
    <>
      <Head title="Medicines" />
      <Content>
        <BlockHead size="sm" className="mb-0 pb-0">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Medicines
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <Button
                color="primary"
                outline
                className="me-n1"
                onClick={() => {
                  navigate("/medicine/add-medicine", { state: { mode: "Add" } });
                  // if (!isOpen) {
                  //   setIsOpen(true);
                  //   setMode("Add");
                  //   reset();
                  // } else {
                  //   setIsOpen(false);
                  // }
                }}
              >
                <Icon name={isOpen ? "minus" : "plus"} />
              </Button>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block className="pt-0">
          {/* <MyDataTable data={tableData} columns={columns} title="Doctors List" isLoading={loading} /> */}
          <ApiPaginationDataTable
            columns={columns}
            data={tableData}
            title={"Medicines List"}
            isLoading={loading}
            register={register}
            trigger={trigger}
            watch={watch}
            setValue={setValue}
            errors={errors}
            totalRows={watch("limit")}
            perPage={watch("perPage")}
            serverSearch
            paginationServer
            serverSideSearch={serverSideSearch}
            handlePageChange={handlePageChange}
            handlePerRowsChange={handlePerRowsChange}

          />
        </Block>
      </Content>


    </>
  );
};

export default User;
